import { Navigate, useRoutes } from 'react-router-dom';
import MainRoutes from './MainRoutes';

export default function ThemeRoutes() {
    return useRoutes([
        MainRoutes,
        {
            path: '/apple-app-site-association',
            element: null,
        },
        {
            path: '*',
            element: <Navigate to="/" replace />,
        },
    ]);
}
